export default __webpack_public_path__ + "static/media/image.trails-for-lanka.09996db3.png";